import { toast } from "react-toastify";

/**
 * 앱 전역 토스트 — 상단 중앙에 뜨고 자동으로 사라진다. 응답을 받지 않는다.
 *
 * 사용자의 확인(클릭)을 받아야 흐름을 진행할 수 있는 경우에는 이걸 쓰지 말고
 * util/confirmDialog 의 confirmNotify() 를 쓴다. (예: 직후에 페이지가 replace 되어
 * 토스트가 화면에서 사라져 버리는 경우)
 *
 * @param {string} message  본문. \n 은 줄바꿈으로 렌더된다(index.css 의 pre-line).
 * @param {"info"|"success"|"warning"|"error"} [type]  기본 "info"
 * @param {object} [options]  react-toastify 옵션 passthrough (autoClose 등).
 *                            여러 줄짜리 결과 요약처럼 기본 2.5초로 부족할 때만 쓴다.
 */
export function notify(message, type = "info", options) {
    const method = type === "warning" ? "warn" : type;
    toast[method]?.(message, options);
}
